<div class="custom-login-container">
  <div class="login-wrapper">
    <abp-card>
      <abp-card-header>
        <div class="text-center mb-4">
          <div class="login-logo mb-3">
            <i class="fas fa-graduation-cap"></i>
          </div>
          <h2 class="login-title">Koçluk Sistemi</h2>
          <p class="login-subtitle" *ngIf="currentStep() === 'login'">Hesabınıza giriş yapın</p>
          <p class="login-subtitle" *ngIf="currentStep() === 'otp'">İki Faktörlü Doğrulama</p>
        </div>
      </abp-card-header>
      
      <abp-card-body>
        <!-- Step 1: Login Form -->
        <form *ngIf="currentStep() === 'login'" [formGroup]="loginForm" (ngSubmit)="onSubmit()" validation>
          <div class="mb-3">
            <div class="form-group">
              <label for="username">Kullanıcı adı veya e-posta</label>
              <input 
                type="text"
                id="username"
                formControlName="username"
                class="form-control form-control-lg"
                placeholder="Kullanıcı adı veya e-posta"
                [class.is-invalid]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
              <div class="invalid-feedback" *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
                <span *ngIf="loginForm.get('username')?.errors?.['required']">Bu alan zorunludur</span>
                <span *ngIf="loginForm.get('username')?.errors?.['minlength']">Bu alan en az 3 karakter olmalıdır</span>
                <span *ngIf="loginForm.get('username')?.errors?.['maxlength']">Bu alan en fazla 50 karakter olabilir</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <div class="form-group">
              <label for="password">Şifre</label>
              <input 
                type="password"
                id="password"
                formControlName="password"
                class="form-control form-control-lg"
                placeholder="Şifre"
                [class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
              <div class="invalid-feedback" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                <span *ngIf="loginForm.get('password')?.errors?.['required']">Bu alan zorunludur</span>
                <span *ngIf="loginForm.get('password')?.errors?.['minlength']">Bu alan en az 6 karakter olmalıdır</span>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-center mb-4">
            <abp-checkbox
              formControlName="rememberMe"
              [label]="'Beni hatırla'"
              checkboxClass="form-check-input">
            </abp-checkbox>
            
            <a 
              class="forgot-password-link" 
              (click)="navigateToForgotPassword()">
              Şifremi unuttum
            </a>
          </div>

          <abp-button
            buttonType="submit"
            buttonClass="btn btn-primary btn-lg btn-block w-100 mb-3"
            [loading]="isLoading()"
            [disabled]="isLoginFormDisabled"
            iconClass="fas fa-sign-in-alt">
            Giriş Yap
          </abp-button>

          <!-- Social Login Divider -->
          <div class="social-login-divider my-4">
            <span>{{ '::Login:OrLoginWith' | abpLocalization }}</span>
          </div>

          <!-- Google Login Button -->
          <button
            type="button"
            class="btn btn-google btn-lg w-100 mb-3"
            (click)="loginWithGoogle()"
            [disabled]="isLoading()">
            <svg class="google-icon" viewBox="0 0 24 24" width="20" height="20">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            {{ '::Login:LoginWithGoogle' | abpLocalization }}
          </button>

        </form>

        <!-- Step 2: OTP Verification Form -->
        <div *ngIf="currentStep() === 'otp'">
          <div class="alert alert-info mb-4">
            <i class="fas fa-shield-alt me-2"></i>
            <strong>{{ userEmail }}</strong> adresine 2FA kodu gönderildi.
            <div class="mt-2" *ngIf="countdownText() && !canResendOtp()">
              <i class="fas fa-clock me-1"></i>
              Kalan süre: <strong>{{ countdownText() }}</strong>
            </div>
            <div class="mt-2" *ngIf="canResendOtp()">
              <span class="text-warning"><i class="fas fa-exclamation-triangle me-1"></i>Kodun süresi doldu. Yeni kod gönderebilirsiniz.</span>
            </div>
          </div>

          <form [formGroup]="otpForm" (ngSubmit)="onSubmit()">
            <div class="mb-4">
              <label for="otpCode" class="form-label">2FA Doğrulama Kodu</label>
              <input
                type="text"
                id="otpCode"
                formControlName="otpCode"
                class="form-control form-control-lg text-center"
                placeholder="000000"
                maxlength="6"
                style="letter-spacing: 0.5em; font-size: 1.5rem;"
                [class.is-invalid]="otpForm.get('otpCode')?.invalid && otpForm.get('otpCode')?.touched">
              <div class="invalid-feedback" *ngIf="otpForm.get('otpCode')?.invalid && otpForm.get('otpCode')?.touched">
                <span *ngIf="otpForm.get('otpCode')?.errors?.['required']">2FA kodu zorunludur</span>
                <span *ngIf="otpForm.get('otpCode')?.errors?.['pattern']">6 haneli sayı giriniz</span>
              </div>
              <div class="form-text text-center text-muted">
                Demo için: 123456 kodunu kullanabilirsiniz
              </div>
            </div>

            <abp-button
              buttonType="submit"
              buttonClass="btn btn-success btn-lg w-100 mb-3"
              [loading]="isLoading()"
              [disabled]="isOtpFormDisabled"
              iconClass="fas fa-shield-alt">
              Doğrula
            </abp-button>

            <div class="text-center">
              <button type="button" class="btn btn-link me-3" (click)="resendOtp()" [disabled]="isResendOtpDisabled">
                <i class="fas fa-redo me-1"></i>
                <span *ngIf="canResendOtp()">Kodu Tekrar Gönder</span>
                <span *ngIf="!canResendOtp()">{{ countdownText() }}</span>
              </button>
              <button type="button" class="btn btn-link" (click)="goBackToLogin()">
                <i class="fas fa-arrow-left me-1"></i>
                Geri Dön
              </button>
            </div>
          </form>
        </div>
      </abp-card-body>
    </abp-card>
  </div>
</div>
